export default __webpack_public_path__ + "static/media/wallet.c272517d.svg";